import gql from 'graphql-tag'

export const GET_CASH_BOX_SOURCE_CATEGORY_PAGINATION_QUERY = gql`
  query GetCashBoxSourceCategoryPagination (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
    $query: String
  ) {
    getCashBoxSourceCategoryPaginated (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
        query: $query
      }
    ) {
      hasMore
      total
      items {
        id
        title
        static
      }
    }
  }
`
